export default "__VITE_ASSET__C325dKk7__"